var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"small":""}},[_vm._v("+")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }